import SentryService from 'app/vanilla/services/Sentry';

/**
 * Retry plugin for Module Federation
 * -------------------------------------------------
 * This plugin is used to retry resources when they fail to load, thereby increasing the success rate of resource loading.
 * In Module Federation, we provide the retry plugin `RetryPlugin` to increase the retry mechanism for remote applications, which can improve the stability of the application.
 *
 * https://module-federation.io/plugin/plugins/retry-plugin.html
 */
const { RetryPlugin } = require('@module-federation/retry-plugin');

export default function retryPlugin() {
  return RetryPlugin({
    retryTimes: 5,
    retryDelay: 1000,
    addQuery: true,
    onRetry: ({ times, url }) => {
      SentryService.captureMicroFrontendBreadcrumb(`Retry [${times}] loading "${url}".`);
    },
    onError: ({ url }) => {
      SentryService.captureMicroFrontendBreadcrumb(`Error loading "${url}".`);
    },
  });
};
